import React from 'react'
import Helmet from 'react-helmet'
import Typist from 'react-typist'
import PageWrapper from '../components/PageWrapper/PageWrapper'
import TextContainer from '../components/TextContainer/TextContainer'
import Divider from '../components/Divider/Divider'
import Inner from '../components/Inner/Inner'
import IconList from '../components/IconList/IconList'
import Button from '../components/Button/Button'
import styles from './solutionsTemplate.module.css'

export default function SolutionsTemplate({ data }) {
  function createContent() {
    return { __html: data.solution.html }
  }

  return (
    <div className={styles.outerWrapper}>
      <Helmet
        title={`${data.solution.frontmatter.title} - Dominion Systems, LLC`}
        meta={[]}
      />
      <PageWrapper>
        <Inner>
          <div className={styles.wrapper}>
            <div className={styles.overlay} />
            <div className={styles.content}>
              <TextContainer>
                <h1>
                  <Typist>
                    <Typist.Delay ms={500} />
                    {data.solution.frontmatter.title}
                  </Typist>
                </h1>
                <Divider />
                <div dangerouslySetInnerHTML={createContent()} />
                <Button title="Get In Touch" link="/contact/" />
              </TextContainer>
            </div>
            <div className={styles.solutions}>
              <IconList items={data.solutions.edges} />
            </div>
          </div>
        </Inner>
      </PageWrapper>
    </div>
  )
}

export const pageQuery = graphql`
  query SolutionBySlug($slug: String!) {
    solution: markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        icon
      }
    }
    solutions: allFile(filter: { sourceInstanceName: { eq: "solutions" } }) {
      edges {
        node {
          childMarkdownRemark {
            fields {
              slug
            }
            frontmatter {
              title
              icon
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/solutionTemplate.js